import { render, staticRenderFns } from "./UberEventAvatar.vue?vue&type=template&id=1bb0dffa&scoped=true&"
import script from "./UberEventAvatar.vue?vue&type=script&lang=js&"
export * from "./UberEventAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UberEventAvatar.vue?vue&type=style&index=0&id=1bb0dffa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb0dffa",
  null
  
)

export default component.exports
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QAvatar});
